//import ApiService from "@/services/ApiService";
import jwtDecode from "jwt-decode";
import store from "@/store";
import UserService from "./UserService";
import WalletService from "./WalletService";

class BootstrapService {
  init() {
    return new Promise((resolve, reject) => {
      this.setupTokenData();
      Promise.all([
        UserService.me(),
        UserService.requestDetails(),
        WalletService.getWalletInstruments()
      ]).then(
        ({ 0: me, 1: details, 2: instruments }) => {
          if (me) {
            store.commit("setUser", me);
          }
          if (details) {
            store.commit("setUser", { details: details });
          }
          if (instruments) {
            store.commit("setWalletInstruments", instruments);
          }
          resolve(me, details, instruments);
        },
        reason => {
          console.log(reason);
          reject();
        }
      );
    });
  }

  setupTokenData() {
    const accessToken = sessionStorage.getItem("cr_at"),
      tokenData = jwtDecode(accessToken);
    store.dispatch("setTokenData", tokenData);
  }
}

export default new BootstrapService();
